import { RankCategoryType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

export const rankCategoryTypeName: { [key in RankCategoryType]: TKeyType } = {
  [RankCategoryType.UPGRADE]: 'common.upRank',
  [RankCategoryType.DOWNGRADE]: 'common.downRank'
}

export default rankCategoryTypeName
